import React from 'react/addons';

const FieldContainer = React.createClass({
  propTypes: {
    label: React.PropTypes.string,
  },

  render() {
    const {label, children} = this.props;
    return (
      <div className="ofs-Form__Field">
        {label ? <label className="ofs-Form__Label">{label}</label> : null}
        {children}
      </div>
    );
  },
});

export default FieldContainer;


/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/react/fields/fieldcontainer.jsx
 **/